import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';

export type QuestionV2Props = IconProps;

export const QuestionV2 = ({ className, ...props }: QuestionV2Props) => (
  <Icon
    className={classNames('question', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}>
    <circle opacity="0.1" cx="8" cy="8" r="7.5" fill="white" stroke="black" />
    <path
      opacity="0.6"
      d="M7.12134 9.60571L7.11621 9.30835C7.06494 8.58032 7.33154 8.11377 8.03906 7.69849C8.70044 7.30371 8.90039 7.04736 8.90039 6.57056V6.56543C8.90039 6.07324 8.50562 5.72461 7.92627 5.72461C7.33667 5.72461 6.95215 6.10913 6.92139 6.63721L6.91626 6.67822H5.52686V6.62695C5.56787 5.42212 6.44458 4.53516 8.01855 4.53516C9.47974 4.53516 10.4539 5.34521 10.4539 6.51929V6.52441C10.4539 7.29346 10.0796 7.83179 9.35669 8.25732C8.6748 8.6521 8.48511 8.90845 8.48511 9.39551V9.60571H7.12134ZM7.82373 12.0615C7.3623 12.0615 6.98804 11.7078 6.98804 11.2566C6.98804 10.8054 7.3623 10.4517 7.82373 10.4517C8.29028 10.4517 8.66455 10.8054 8.66455 11.2566C8.66455 11.7078 8.29028 12.0615 7.82373 12.0615Z"
      fill="black"
    />
  </Icon>
);
